export enum RouteLineTableRowVariant {
  Timetables,
  RoutesAndLines,
}
